import { CodeBook } from "@king-ict/eupisi-ui/models";

import { CommitteeEmployee } from "./CommitteeEmployee";

// request/get-institution-county-committees/${requestId}
export interface CommitteeResponse {
  institutionCommittees: Committee[];
  hasInstitutionWithMinDecisionNumber: boolean;
  countyCommittees: Committee[];
  hasCountyWithMinDecisionNumber: boolean;
}

export interface Committee {
  id: number;
  dateFrom?: Date | string;
  dateTo?: Date | string;
  note?: string | null;
  statusId: CommitteeStatus;
  employees?: CommitteeEmployee[];

  statusName: string; // Croatian translation of enum CommitteeStatus

  // These are helper properties
  isSelected?: boolean;
}

export enum CommitteeStatus {
  NotDefined = 1,
  ConfirmationRequired,
  Rejected,
  Granted,
  Inactive,
}

export interface Institution extends CodeBook {
  oib: string;
  code: string;
  subCode: string;
  typeId?: number | null;
  statusId?: number;
  address?: InstitutionAddress;
}

export interface InstitutionAddress {
  addressLine1: string;
  addressLine2: string | null;
  town: CodeBook;
}
